import { createTransform } from 'redux-persist';
import CryptoJS from 'crypto-js';

const secretKey = 'upncomer@karn@25#rks'; 

const encrypt = (state) => {
    const jsonState = JSON.stringify(state);
    return CryptoJS.AES.encrypt(jsonState, secretKey).toString();
};

const decrypt = (state) => {
    const bytes = CryptoJS.AES.decrypt(state, secretKey);
    const jsonState = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(jsonState);
};
// Transform for growthEngine reducer
const growthEngineTransform = createTransform(
    (inboundState) => encrypt(inboundState),
    (outboundState) => decrypt(outboundState),
    { whitelist: ['growthEngine'] }
);

// Transform for dataAnalysis reducer – only persist searchQuery
const dataAnalysisTransform = createTransform(
    (inboundState) => encrypt({ searchQuery: inboundState.searchQuery }),
    (outboundState) => {
        const decrypted = decrypt(outboundState);
        return { searchQuery: decrypted.searchQuery };
    },
    { whitelist: ['dataanalyst'] }
);

// Transform for audioEngineer reducer — only persist uploadedData
const audioEngineerTransform = createTransform(
    (inboundState) => {
        return encrypt({ 
            uploadedData: inboundState.uploadedData ?? {},
            ongoingProcesses: inboundState.ongoingProcesses ?? [],
            mixMetaData: inboundState.mixMetaData ?? {},
            uploadedFiles: inboundState.uploadedFiles ?? []
        });
    },
    (outboundState) => {
        try {
            const decrypted = decrypt(outboundState);
            return { 
                uploadedData: decrypted.uploadedData ?? {},
                ongoingProcesses: decrypted.ongoingProcesses ?? [],
                mixMetaData: decrypted.mixMetaData ?? {},
                uploadedFiles: decrypted.uploadedFiles ?? []
            };
        } catch (e) {
            console.warn('audioEngineerTransform decrypt failed:', e);
            return { uploadedData: {}, ongoingProcesses: [], mixMetaData: {}, uploadedFiles: []};
        }
    },
    { whitelist: ['audioEngineer'] }
);
 
const isRewardNotification = (notification) =>
    Boolean(notification?.rewardId || String(notification?.id || '').startsWith('reward-'));

const backgroundProcessesTransform = createTransform(
    (inboundState) => inboundState,
    (outboundState) => {
        if (!outboundState) return outboundState;
        const notifications = Array.isArray(outboundState.notifications)
            ? outboundState.notifications.filter((notification) => !isRewardNotification(notification))
            : [];
        return { ...outboundState, notifications };
    },
    { whitelist: ['backgroundProcesses'] }
);

export { growthEngineTransform, dataAnalysisTransform, audioEngineerTransform, backgroundProcessesTransform };

// const transform = createTransform(
//     // transform state on its way to being serialized and persisted
//     (inboundState) => {
//         return encrypt(inboundState);
//     },
//     // transform state being rehydrated
//     (outboundState) => {
//         return decrypt(outboundState);
//     },
//     // define which reducers this transform gets applied to
//     { whitelist: ['growthEngine', 'dataanalyst'] } // Can Apply to multiple reducers
// );

// export default transform;